import { useState, useEffect } from "react";
import { useAuth } from "./useAuth";

// Simple hook to get user ID - using email as identifier since your backend checks by email
export const useCurrentUserId = (): string | null => {
  const { currentAccount, isAuthenticated } = useAuth();
  const [userId, setUserId] = useState<string | null>(null);

  useEffect(() => {
    if (isAuthenticated && currentAccount) {
      // For now, use email as user identifier
      // Your backend can map this to the actual database user ID
      const userEmail = currentAccount.username || currentAccount.name;
      setUserId(userEmail || null);
    } else {
      setUserId(null);
    }
  }, [isAuthenticated, currentAccount]);

  return userId;
};
